import {apiClient} from "@/state/modules/apiClient";
const controller = "Mail";
export const actions = {
    async getPagingParams({commit}, params) {
        return apiClient.post(controller + "/get-paging-params", params);
    },
    async getPagingParamsDaGui({commit}, params) {
        return apiClient.post(controller + "/get-paging-params-dagui", params);
    },
    async getPagingParamsRac({commit}, params) {
        return apiClient.post(controller + "/get-paging-params-rac", params);
    },
    async createSend({commit}, values) {
        return apiClient.post(controller + "/create-send", values);
    },
    async deleteMail({commit}, id) {
        return await apiClient.delete(controller + "/delete-mail/" + id);
    },
    async deleteR({commit}, id) {
        return await apiClient.delete(controller + "/deleter/" + id);
    },
    async getById({commit}, id) {
        return apiClient.get(controller + "/get-by-id/" + id);
    },
    async getUserByHopThuId({ commit, dispatch},values) {
        return apiClient.post(controller + "/get-user-by-hop-thu-id",values);
    },
    async changeStatus({commit}, id) {
        return apiClient.get(controller + "/change-status/" + id);
    },
    async getPagingMainMail({commit}, params) {
        return apiClient.post(controller + "/get-paging-params-main-mail", params);
    },
    async deleteAllMail({commit}, id) {
        return await apiClient.delete(controller + "/delete-all-mail/" + id);
    },
    async updateAllMail({commit}, values) {
        return await apiClient.post(controller + "/update-all-mail", values);
    },
    async getUserReply({commit}, id) {
        return apiClient.get(controller + "/get-user-reply/" + id);
    },
};
